import { useState } from 'react'
import DefaultModal from '../../Utils/DefaultModal'
import { Alert, TextField, Box, Typography } from '@mui/material'
import ColorButton from '../../Buttons/ColorButton'
import { api } from '../../../services/api'
import toast from 'react-hot-toast'
import MegaAutoComplete from '../../Utils/megautocomplete'
import IntegerOnly from '../../Utils/IntegerOnly'
import { formatPercentage } from '../../Utils/IntegerOnly'


const validate = async (flag, debito, paymentCondition, desc, setPaymentCondition) => {
    const res = await api.post('/novopedido/taxa_cartao/', {
        flag: flag,  debito:debito, payment_condition: paymentCondition, val_desc: desc})
    if (res.status === 200){
        const new_payment_condition = {...paymentCondition, 
            fromCard: true, 
            data: {val_desc: res.data, origin_desc: paymentCondition?.data?.val_desc || 0},
            debito:debito}
        if (debito)
            new_payment_condition.avista = true
        setPaymentCondition(new_payment_condition)
        return
    }
    toast.error('Falha para validar taxa do cartão')
}

const SelectCard = ({ values_table, data, handleClose, submit }) => {

    const [flag, setFlag] = useState(data?.flag || '')
    const [debito, setDebito] = useState([0, 1].includes(data?.debito) ? data.debito : 3)
    const [paymentCondition, setPaymentCondition] = useState(data?.payment_condition?.fromCard ? data.payment_condition : '')

    return (
        <DefaultModal
            open={true}
            handleClose={handleClose}
            title='Cartão de crédito'
            content={
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.5rem' }}>
                        <MegaAutoComplete
                            fullWidth={true}
                            value={flag}
                            initializeOptions={flag ? [flag] : null}
                            onChange={(value) => {setFlag(value); setDebito(null); setPaymentCondition('')}}
                            noOptionsText={'Digite para procurar uma bandeira'}
                            timeoutUrl='/novopedido/bandeiras/'
                            timeoutParam='label'
                            label='Bandeira'
                            sx={{ maxWidth: '10rem' }}
                        />
                    </Box>
                    <Box className='box-button-selector'>
                        <ColorButton bhColor={'#e7e7e7ff'} disabled={flag?.data?.tipo === 2 || !flag} reverse={debito === 0 ? '' : 'contained'} onClick={() => {setFlag({...flag}); setPaymentCondition(''); setDebito(0)}}>Crédito</ColorButton>
                        <ColorButton bhColor={'#e7e7e7ff'} disabled={flag?.data?.tipo === 3 || !flag} reverse={debito === 1 ? '' : 'contained'} onClick={() => {setFlag({...flag}); setPaymentCondition(''); setDebito(1)}}>Débito</ColorButton>
                    </Box>
                    {!debito ? <MegaAutoComplete
                        disabled={!flag}
                        key={'mega-auto-complete-credito'}
                        value={paymentCondition}
                        initializeOptions={paymentCondition ? [paymentCondition] : null}
                        onChange={(d) => {setFlag({...flag}); setPaymentCondition(d)}}
                        noOptionsText={'Digite para procurar uma condição de pagamento'}
                        timeoutUrl='/novopedido/condicao_pagamento/?parcelas=true'
                        timeoutParam='label'
                        label='Condição de Pagamento'
                    />
                    :
                    <MegaAutoComplete
                        disabled={!flag}
                        key={'mega-auto-complete-debito'}
                        value={paymentCondition}
                        initializeOptions={paymentCondition ? [paymentCondition] : null}
                        onChange={(d) => {setFlag({...flag}); setPaymentCondition(d)}}
                        noOptionsText={'Digite para procurar uma condição de pagamento'}
                        timeoutUrl='/novopedido/condicao_pagamento/?debito=true'
                        timeoutParam='label'
                        label='Condição de Pagamento'
                    />
                }

                    <Box sx={{display:'flex', gap: '1rem'}}>
                        <Box>
                            Desconto/Acréscimo:
                        </Box>
                        <Typography variant="body1" sx={{ fontWeight: 'bold', color: paymentCondition?.data?.val_desc * -1 < 0 ? '#c60000' : 'blue' }}>
                            {formatPercentage(paymentCondition?.fromCard ? paymentCondition?.data?.val_desc * -1:0)}
                            </Typography>
                        </Box>
                    </Box>
            }
            action={
                <> 
                    {!paymentCondition?.fromCard ? <ColorButton
                        disabled={(flag === '' || debito === 3 || !paymentCondition)}
                        onClick={() => validate(flag, debito, paymentCondition, values_table?.data?.desc || 0, setPaymentCondition)}
                    >Validar</ColorButton>
                        :
                    <ColorButton
                        onClick={() => submit(flag, debito, paymentCondition)}
                    >Salvar</ColorButton>}
                </>
            }

        />
    )
}

export default SelectCard